import React, { FC, useEffect, useState } from "react";
import Select from "../../../components/Select";
import stl from "./index.module.scss";
import { useStore } from "effector-react";
import { $currentLocale } from "../../../store/shared/locales";
import MultipleDropdownCalendar from "../../../components/Picker/MultipleDropdownCalendar";
import parse from "date-fns/parse";
import format from "date-fns/format";
import isBefore from "date-fns/isBefore";
import uniqBy from "lodash/uniqBy";
import {
  $selectedDates,
  setSelectedDates,
  $selectedPreferredDays,
  setSelectedPreferredDays,
} from "../../../store/selected/selectedDateRange";

const today = new Date();
today.setHours(0, 0, 0, 0);

const WithDayPreference: FC = () => {
  const dateRange = useStore($selectedDates);
  const selectedPreferredDays = useStore($selectedPreferredDays);

  const [weekDays, setWeekDays] = useState<{ key: number; name: string }[]>([]);

  const { dateFnsLocale: locale } = useStore($currentLocale);

  useEffect(() => {
    // setLocalDateRange(dateRange);
    if (dateRange) {
      const weekDaysFromRange = dateRange.map((date) => ({
        key: date.getDay() - 1,
        name: format(date, "EEEEEEE", { locale }),
      }));

      setWeekDays(uniqBy(weekDaysFromRange, "key"));
    }
  }, [locale, dateRange]);

  return (
    <div className={stl.block}>
      <MultipleDropdownCalendar
        className={stl.datesPicker}
        calendarProps={{
          value: dateRange,
          onChange: setSelectedDates,
          disabledDays: (date) => isBefore(date, today),
        }}
      />
      <span className={stl.divider} />
      <Select
        style={{ display: "none" }} // hidden it as we dont need it any more (most likely)
        variant={"unstyled"}
        mode={"multiple"}
        value={selectedPreferredDays ?? undefined}
        onChange={setSelectedPreferredDays as any}
        className={stl.select}
        placeholder={"All days"}
        dropdownClassName={stl.selectDropdown}
        tagRender={(props) => {
          let label: string = props.label as any;
          try {
            const date = parse(label, "EEEEEEE", new Date());
            label = format(date, "ccc", { locale });
          } catch (e) {
            console.log(
              "DateRangeWithDayPref: error parsing label",
              JSON.stringify(props)
            );
          }
          return (
            <span className="rc-select-selection-item" onClick={props.onClose}>
              <span className="rc-select-selection-item-content">{label}</span>
              <span className="rc-select-selection-item-remove">
                <span className="rc-select-selection-item-remove-icon">×</span>
              </span>
            </span>
          );
        }}
      >
        {weekDays.map(({ key, name }) => (
          <Select.Option key={name} value={key}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default WithDayPreference;
